const getters = {
  /*登录*/
  user: state => state.user.user,
	isLogin: state => state.user.isLogin,
  //栏目
  catesBarList: state => state.admin.catesBarList,
  worksList: state => state.admin.worksList,
  worksDetail: state => state.admin.worksDetail,
  // 办理中工单
  worksComList: state => state.admin.worksComList,
  currentPointer: state => state.admin.currentPointer,
  // 已完结工单
  worksFinishList: state => state.admin.worksFinishList,
  // 今日新增-服务管理
  chartTodayList: state => state.admin.chartTodayList,
  // 今日处理-服务管理
  chartFinished: state => state.admin.chartFinished,
  // 处理中-服务管理
  chartDoing: state => state.admin.chartDoing,
  // 工单总数
  chartCount: state => state.admin.chartCount,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js